import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TopNavigation from "./TopNavigation";
import MobileBottomNavigation from "./MobileBottomNavigation";
import { useManagerAuth } from "@/hooks/useManagerAuth";

const ManagerLayout = () => {
  const navigate = useNavigate();
  const { isLoading, isMemberAuthenticated } = useManagerAuth();

  useEffect(() => {
    if (!isLoading && !isMemberAuthenticated) {
      console.log('ManagerLayout: User not authenticated, redirecting to auth page');
      navigate('/auth');
    }
  }, [isLoading, isMemberAuthenticated, navigate]);

  // Show loading while auth is being checked
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#F4F6F8] to-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2F80ED] mx-auto mb-4"></div>
          <p className="text-[#2F80ED]">Loading...</p>
        </div>
      </div>
    );
  }

  // Don't render layout if user is not authenticated
  if (!isMemberAuthenticated) {
    return null;
  }

  return (
    <>
      <TopNavigation />
      <Outlet />
      <MobileBottomNavigation />
    </>
  );
};

export default ManagerLayout;